export function Logo({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center ${className}`} data-testid="app-logo">
      <span className={`${s} font-extrabold tracking-tight`}>
        <span className="text-sky-400">STAFF</span>
        <span className="text-current">ERA</span>
      </span>
    </div>
  );
}
